import { render, staticRenderFns } from "./underMaintanicace.vue?vue&type=template&id=4d2e2b15&scoped=true&lang=html&"
import script from "./underMaintanicace.vue?vue&type=script&lang=js&"
export * from "./underMaintanicace.vue?vue&type=script&lang=js&"
import style0 from "./underMaintanicace.vue?vue&type=style&index=0&id=4d2e2b15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e2b15",
  null
  
)

export default component.exports